import { render, staticRenderFns } from "./CFileManagerItem.vue?vue&type=template&id=ed713ca0&scoped=true&"
import script from "./CFileManagerItem.vue?vue&type=script&lang=ts&"
export * from "./CFileManagerItem.vue?vue&type=script&lang=ts&"
import style0 from "./CFileManagerItem.vue?vue&type=style&index=0&id=ed713ca0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed713ca0",
  null
  
)

export default component.exports